export default __webpack_public_path__ + "static/media/iPhone-Premium-0.5355e31b.png";